import { render } from "./editExpense.vue?vue&type=template&id=789bc5c1&scoped=true"
import script from "./editExpense.vue?vue&type=script&lang=js"
export * from "./editExpense.vue?vue&type=script&lang=js"

import "./editExpense.vue?vue&type=style&index=0&id=789bc5c1&scoped=true&lang=css"

import exportComponent from "E:\\workspace2017\\vue3.0\\premia-user-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-789bc5c1"]])

export default __exports__